import { useChat } from "../../contexts/useChatData";
import { useMediaQuery } from "@react-hook/media-query";
import { useState, useEffect } from "react";
import styles from "./NewChat.module.css";
import { useUser } from "../../contexts/useUserData";
import { sendFlagNewChat, fetchImageUrl } from "../../api";
import { dataUserReq } from "../../api/models";

interface Props {
    menuOpen: Function;
    openChat: Boolean;
    id?: string;
    setImageUrls: (urls: string[]) => void;
    seccion: string;
}

export const NewChat = (propsData: Props) => {
    const { cleanAnswers, isLoading, inputDisabled, putInputDisabled } = useChat();
    const isResponsive = useMediaQuery("(max-width: 768px)");
    const [openChat, setOpenChat] = useState(false);
    const { scope, token } = useUser();
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    useEffect(() => {
        if (propsData.openChat) {
            setOpenChat(false);
        }
    }, [propsData.openChat]);

    useEffect(() => {
        const newChatElement = document.getElementById("new-chat");

        if (newChatElement) {
            if (isLoading || isButtonDisabled) {
                newChatElement.setAttribute("disabled", "true");
                newChatElement.classList.add("disabled-opacity");
            } else {
                newChatElement.removeAttribute("disabled");
                newChatElement.classList.remove("disabled-opacity");
            }
        }
    }, [isLoading, isButtonDisabled]);

    async function handleClick() {
        if (isButtonDisabled) {
            return;
        }

        const buttonClickTime = Date.now();
        cleanAnswers!(true);
        setOpenChat(false);
        const user_data: dataUserReq = {
            scope: scope!,
            negocio: propsData.seccion!,
            password: "",
            isTest: "",
        };

        let final_token = "";
        if (token) {
            final_token = token;
        }
        
        setIsButtonDisabled(true);
        let names: string[] = [];
        try {
            const { urls, names: fetchedNames } = await fetchImageUrl(propsData.seccion!);
            propsData.setImageUrls(urls);
            names = fetchedNames;
            // y puedes usar names donde lo necesites
        } catch (e) {
            propsData.setImageUrls([]);
            names = [];
        }

        sendFlagNewChat(user_data, final_token, buttonClickTime, names);

        setTimeout(() => {
            setIsButtonDisabled(false);
        }, 100);
    }

    return (
        <div className={styles.newChatModule}>
            <button
                id={propsData.id ?? "new-chat"}
                type="button"
                className={`btn btn-transparent ${styles.newChatModule} ${(isLoading || isButtonDisabled || inputDisabled) ? "disabled-opacity" : ""}`}
                onClick={handleClick}
                disabled={isLoading || isButtonDisabled || inputDisabled}
            >
                <strong>Nuevo<br />chat</strong>
            </button>
        </div>
    );
};
